import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import CircularProgress from "@mui/material/CircularProgress";
import BootcampDetail from "components/BootcampDetail";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { adminApi } from "services/api";

const BootcampDetailPage = () => {
  const { slug } = useParams();
  const [bootcamp, setBootcamp] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchBootcamp = async () => {
      try {
        const data = await adminApi.getBootcampBySlug(slug);
        setBootcamp(data);
      } catch (err) {
        setError("Bootcamp not found");
      } finally {
        setLoading(false);
      }
    };
    fetchBootcamp();
  }, [slug]);

  // Inside the dashboard shell so the page gets the navbar (with the phone menu button), the
  // responsive side padding, and clears the fixed sidenav on desktop.
  let content = null;
  if (loading) content = <CircularProgress />;
  else if (error) content = <MDTypography color="error">{error}</MDTypography>;
  else if (bootcamp) content = <BootcampDetail bootcamp={bootcamp} />;

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={4}>{content}</MDBox>
    </DashboardLayout>
  );
};

export default BootcampDetailPage;
